import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";

export function PwaUpdatePrompt() {
  const [show, setShow] = useState(false);
  const [reg, setReg] = useState<ServiceWorkerRegistration | null>(null);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    navigator.serviceWorker.getRegistration().then((r) => {
      if (!r) return;
      setReg(r);

      const check = () => {
        if (r.waiting) setShow(true);
      };

      check();
      r.addEventListener("updatefound", () => {
        r.installing?.addEventListener("statechange", check);
      });
    });

    navigator.serviceWorker.addEventListener("controllerchange", () => {
      window.location.reload();
    });
  }, []);

  if (!show) return null;

  function apply() {
    reg?.waiting?.postMessage({ type: "SKIP_WAITING" });
  }

  return (
    <div
      role="status"
      className="fixed bottom-4 left-1/2 z-50 flex -translate-x-1/2 items-center gap-3 rounded-xl bg-portal-text px-4 py-3 shadow-xl"
    >
      <RefreshCw className="h-4 w-4 flex-shrink-0 text-brand-orange" />
      <p className="text-sm font-semibold text-white">Update available</p>
      <button
        onClick={apply}
        className="rounded-lg bg-brand-orange px-3 py-1.5 text-xs font-bold text-white hover:bg-brand-orange/90"
      >
        Reload
      </button>
      <button
        onClick={() => setShow(false)}
        className="text-xs text-gray-400 hover:text-white"
        aria-label="Dismiss update prompt"
      >
        Later
      </button>
    </div>
  );
}
